import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { api } from "@/lib/api";

const DashboardContext = createContext(null);
export const useDashboard = () => useContext(DashboardContext);

export function AppShell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const goto = localStorage.getItem("orbit_goto");
    if (goto) {
      localStorage.removeItem("orbit_goto");
      navigate(goto, { replace: true });
    }
  }, [navigate]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get("/dashboard");
      setData(data);
    } catch (e) {
      setError(e.response?.data?.detail || "We couldn't load your workspace.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const orgName = data?.organisation_name || data?.profile?.business_name;

  return (
    <DashboardContext.Provider value={{ data, loading, error, refresh: load }}>
      <div className="flex min-h-screen bg-background">
        <Sidebar open={open} onClose={() => setOpen(false)} />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar onMenu={() => setOpen(true)} orgName={orgName} isDemo={data?.is_demo} />
          <main className="flex-1 px-4 py-6 sm:px-6 lg:px-10 lg:py-10">
            <div className="mx-auto max-w-7xl">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </DashboardContext.Provider>
  );
}
